import { atom } from "jotai";

import { currentBookingAtom } from "../../stores";

export const isAllMemberGroupAtom = atom((get) => {
  const booking = get(currentBookingAtom);

  if (booking?.rounds.length === 0) return false;

  return (
    booking?.rounds.every((round) => round.player.clientType === "member") ??
    false
  );
});
